import { render, staticRenderFns } from "./productSubType.vue?vue&type=template&id=049ec80a&"
import script from "./productSubType.vue?vue&type=script&lang=js&"
export * from "./productSubType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports